import { type FC } from "react";
import {
  useStreamEntrypointMonitoringQuery,
  type StreamEntrypoint,
} from "@/partner/entities/streamEntrypoints";
import {
  LiveInputMonitoringView,
  useMonitoringPeriod,
} from "@/partner/features/liveInputMonitoring";

interface StreamEntrypointMonitoringTabProps {
  entrypoint: StreamEntrypoint;
}

// Вкладка «Мониторинг»: по образцу StreamMonitoringTab.tsx (streams-фича),
// но у точки входа нет окна конкретного эфира (broadcast), только режимы
// «сейчас» и календарные периоды (live = entrypoint.liveConnected). Свой
// DialogHeader не рендерит: общий хедер живёт в шелле StreamEntrypointForm.tsx.
export const StreamEntrypointMonitoringTab: FC<
  StreamEntrypointMonitoringTabProps
> = ({ entrypoint }) => {
  const { period, setPeriod, range, periods } = useMonitoringPeriod({
    live: entrypoint.liveConnected,
    broadcast: null,
  });
  // Как в StreamMonitoringTab: previousData на время перезапроса по новому
  // тику, чтобы не мигать скелетонами; no-cache против роста кеша Apollo.
  const { data, previousData, loading, error } =
    useStreamEntrypointMonitoringQuery({
      variables: { id: entrypoint.id, from: range.from, to: range.to },
      fetchPolicy: "no-cache",
    });
  const shown = data ?? previousData;
  return (
    <LiveInputMonitoringView
      monitoring={shown?.streamEntrypoint?.monitoring}
      loading={loading && !previousData}
      error={error}
      period={period}
      periods={periods}
      onChangePeriod={setPeriod}
      viewersOnline={shown?.streamEntrypoint?.stream?.viewersOnline ?? null}
      // У точки входа нет статуса эфира: сигнал показываем, если он есть.
      signal={shown?.streamEntrypoint?.signal ?? null}
    />
  );
};
